export default __webpack_public_path__ + "static/media/certify-logo.23cb9e86.svg";